import React from 'react';
import { motion } from 'framer-motion';
import { previewImage } from '../data/content';
import { CtaButton } from './CtaButton';
export function InsidePreview() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="inside-heading" data-id="element-113" data-mp="2ma398y18bncx">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-114" data-mp="2mc5y3eqnbag2">
        <p className="font-display text-sm font-bold uppercase tracking-wide text-lilac-400" data-id="element-115" data-mp="2hc1n248ib7x8">
          See what&apos;s waiting inside
        </p>
        <h2 id="inside-heading" className="mx-auto mt-2 max-w-2xl font-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-116" data-mp="3f0l8fnyu14l2">
          Take a peek at My Magical World of Paper
        </h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} className="mt-8 overflow-hidden rounded-4xl border-4 border-blush-100 shadow-card" data-id="element-117" data-mp="30amdrv6hkbac">
          <img src={previewImage} alt="The full kit laid out on a table: box, lookbook, printed dolls, dresses, paper rooms, furniture and a dollhouse" className="h-full w-full object-cover" loading="lazy" data-id="element-118" data-mp="3lq1q9nk91err" />
        </motion.div>

        <p className="mt-6 font-display text-lg font-bold text-ink" data-id="element-119" data-mp="3gxruhqwgdkhk">
          150+ paper dolls · 30 themes · 3 FREE bonuses
        </p>
        <p className="mt-2 flex items-center justify-center gap-3" data-id="element-120" data-mp="3314vzjouqm9j">
          <span className="text-base text-ink/50 line-through" data-id="element-121" data-mp="371ez8ol9eykp">$85 total value</span>
          <span className="font-display text-3xl font-extrabold text-blush-500" data-id="element-122" data-mp="2t1w5j0t73prx">$27</span>
        </p>
        <p className="mt-1 text-sm text-ink/60" data-id="element-123" data-mp="2y10aff9371cg">
          One-time payment · Instant digital access
        </p>

        <div className="mt-6" data-id="element-124" data-mp="ra0vsqqi1vcc">
          <CtaButton data-id="element-125" data-mp="r7ogymg1g13i">I want my kit today!</CtaButton>
        </div>
      </div>
    </section>;
}